module.exports = __webpack_public_path__ + "assets/img/sh18.a85e982c.jpg";